import { useMutation } from '@tanstack/react-query';

import { clientApi } from '@/config/axios';

export interface ProfileResponse {
  email: string;
  id: string;
  is_superuser: boolean;
  name: string;
}

export interface UpdateProfilePayload {
  name: string;
}

/**
 * Change the signed-in user's own display name.
 *
 * Unlike `useChangePassword` this sends no current password: a display name is
 * not a credential, and changing it cannot lock the owner out. The API accepts
 * only `name` — email and password have their own paths, both of which
 * re-authenticate first.
 */
export function useUpdateProfile() {
  return useMutation({
    mutationFn: async (payload: UpdateProfilePayload) => {
      const { data } = await clientApi.patch<ProfileResponse>('/api/v1/auth/me', payload);
      return data;
    },
  });
}
